"use strict";

module.exports = {
  'name': 'complex',
  'category': 'Construction',
  'syntax': ['complex()', 'complex(re, im)', 'complex(string)'],
  'description': 'Create a complex number.',
  'examples': ['complex()', 'complex(2, 3)', 'complex("7 - 2i")'],
  'seealso': ['bignumber', 'boolean', 'index', 'matrix', 'number', 'string', 'unit']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/construction/complex.js
// module id = 802
// module chunks = 0